import ApiService from '@/services/ApiService';

const url = 'https://blog.taskflex.dk/wp-json/wp/v2';

const query = (resource = 'posts', options, callback, errorCallback) => {
    ApiService.get(`${url}/${resource}`, options, callback, errorCallback, { baseUrl: url });
};

export default {
    query,
};



// WEBPACK FOOTER //
// ./src/taskflex/blog/services/BlogService.js